import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, course_id, isToCopy = true) => {
  return makeRequest(
    'post',
    `/api/live_discussions/${roundtable_id}/duplicate`,
    {
      course_id,
      isToCopy
    }
  ).then((res) => res.data);
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/duplicateLiveDiscussion.js